import { Component, OnInit } from '@angular/core';

import { UserProfileService, DownloadService } from '../../core';
import { Router } from '@angular/router';



@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  fileList:string[]=[
    "BARlist.csv",
    "Completelist.csv",
    "EveryRate.csv",
    "GDSErrors.csv",
    "Worklist.csv",
    "BARFindingState.json",
    "Log.txt",
  ];

  constructor(
    private downloadService:DownloadService,
    private userProfileService:UserProfileService
    , private router: Router

  ) {

  }

  isSuperUser:boolean = false;
  ngOnInit() {
    this.isSuperUser = this.userProfileService.data.RoleList.includes("Super User");

    if(!(this.isSuperUser || this.userProfileService.data.CustomerName.toLowerCase() == "lanyonmaster")){
      this.router.navigate(['/main']);
    }


  }
  report1="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=AuditAvl_ListAuditsReport&";
  report2="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=AuditStd_ListAuditsReport&";
  report3="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=AuditRvr_ListAuditResultsReport&";
  report4="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=AuditRvr_ListAuditsReport&";
  report5="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=AuditStd_SabreLikleyBadIPCReport&";
  report6="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=AuditStd_AuditPropertyReport&";
  report7="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=MessageLog_ListReport&";
  auditID="9e05cd86-dd59-4eea-a427-0312c54de60f";
  report8="NA=a&AuditID=" + this.auditID + "&SSRS_Parameter_List=NA|AuditID&SSRS_Report_Name=AuditStd_AuditPropertyReport&";
  report9="StartDate=01/01/2020&EndDate=12/31/2020&SSRS_Parameter_List=StartDate|EndDate&SSRS_Report_Name=MonthlyCounts&";
  report10="NA=a&SSRS_Parameter_List=NA&SSRS_Report_Name=Log_RecentLogReport&";

  SubmitReport(reportInfo:string){
    this.downloadService.downloadAdminReport(reportInfo)
      .subscribe();

  }


  SubmitDownloadBARProcessorFile(index:number){
    if(index < this.fileList.length){
      this.downloadService.downloadBARProcessorFile(this.fileList[index])
      .subscribe();
    }
  }
}
